<template>
  <SingleNumberFrame
      title="Average Sessions Per Passenger"
      :value="formattedValue"
  >
    <template v-slot:icon>
      <icon-blue
          v-if="iconColor === 'blue'"
      />
      <icon-white
          v-if="iconColor === 'white'"
      />
    </template>
  </SingleNumberFrame>
</template>

<script>

import iconBlue from '../../../../../public/img/cil-group-blue.svg';
import iconWhite from '../../../../../public/img/cil-group.svg';
import SingleNumberFrame from './SingleNumberFrame.vue';

export default {
  name: 'SingleNumberFrameAverageSessionsPerPassenger',
  components: {
    iconBlue,
    iconWhite,
    SingleNumberFrame,
  },

  props: {
    itemData: {
      type: [Number, String],
      default: null,
    },

    iconColor: {
      type: String,
      default: 'blue',
    },
  },

  computed: {
    formattedValue() {
      const value = Number(this.itemData);

      return Number.isFinite(value) ? value.toFixed(2) : '0.00';
    },
  },
};
</script>
